import React from "react";
import { Sidebar } from "../Sidebar/Sidebar";
import { Grid } from "../../style/Dashboard";
import { Navbar } from "../Navbar/Navbar";
import {
  Scheduler,
  Appointments,
  WeekView,
  Resources,
} from "@devexpress/dx-react-scheduler-material-ui";
import appointments from "../../data/today";
import {
  CalenderConatainer,
  CustomCalender,
  CustomPaper,
} from "../../style/Calender";
import "./calextended.css";

import { Provider } from "./Provider";
import AdHorizontal from "../../assets/Ads/Horizontal.jpeg";
import AdVertical from "../../assets/Ads/vertical.jpeg";
import { CustomDiv } from "../../style/shared";
import { Logo2 } from "../logo/Logo";
import { render } from "@testing-library/react";
import moment from "moment";
import { grey } from "@material-ui/core/colors";
import { verifyAuth } from "../../authverify";
import AdvertiserCard from "../common/card";
import Mycontext from "../../store/Mycontext";
import MedizenCreative from "../NewCreatives/MedizenCreative/MedizenCreative";
import PrimeraCreative from "../NewCreatives/PrimeraCreative/PrimeraCreative";
import PanazCreative from "../NewCreatives/PanazCreative/PanazCreative";
import MedizenVerticalAd from "../../assets/Ads/MedizenV.jpg";
import PrimeraVerticalAd from "../../assets/Ads/PrimeraV.jpg";
import PanazVerticalAd from "../../assets/Ads/PanazV.jpg";
import { htmls } from "../../constants";


//const [value, onChange] = React.useState(new Date());
const loginAds = {
  1: <MedizenCreative />,
  2: <PrimeraCreative />,
  3: <PanazCreative />,
};

const loginAds1 = {
  1: MedizenVerticalAd,
  2: PrimeraVerticalAd,
  3: PanazVerticalAd,
};


const dayOfWeekNames = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
function renderDateCell(cellData) {
  alert("Called");
  return (
    <React.Fragment>
      <div>{dayOfWeekNames[cellData.date.getDay()]}</div>
      <div>{cellData.date.getDate()}</div>
    </React.Fragment>
  );
}

const Appointment = ({ children, style, onClick, ...restProps }) => {
  const value = { ...restProps };
  return (
    <Appointments.Appointment
      className={value.data.id === 1 ? "anime" : ""}
      {...restProps}
      onClick={(e) => {
        if (e.data.id === 1) {
          window.redcomp.onHistory();
        }
      }}
      style={{
        ...style,
        borderRadius: "0px",
        width: "120px",
        fontSize: "11px",
        color: "black !important",
      }}
    >
      {children}
    </Appointments.Appointment>
  );
};

export class Calender extends React.Component {
  constructor(props) {
    super(props);
    window.redcomp = this;
    this.state = {
      bannerType: null,
      value: new Date(),
      resources: [
        {
          fieldName: "id",
          title: "title",
          instances: appointments,
        },
      ],
    };
    this.adConfig = localStorage.getItem("creativeConfig") ? JSON.parse(localStorage.getItem("creativeConfig")) : null;
    console.log(">>>> adConfig", this.adConfig);
    this.showAd = this.adConfig && this.adConfig.workflowWithAdds ? this.adConfig.workflowWithAdds.includes("Calendar/Waiting Room") : false;

    this.onChange = this.onChange.bind(this);

    if (!verifyAuth()) {
      this.props.history.push({
        pathname: "/",
      });
    }
  }

  

  getBannerType ()  {
    const len = this.adConfig ? this.adConfig.creative_size.length : 0;
    if (len === 0) return null;
    const newRandValue = Math.floor(Math.random() * len);
    return this.adConfig.creative_size[newRandValue];
  };
  componentDidMount() {
    let toSetBannerType = this.getBannerType();
    while( this.adConfig && toSetBannerType === 'react' && (this.adConfig.creative_size.includes('vertical') || this.adConfig.creative_size.includes('horizontal'))) toSetBannerType = this.getBannerType();
    this.setState({ ...this.state, bannerType: toSetBannerType });
  }

  onChange = () => {
    this.state.value = this.state.value + 1;
  };

  onHistory = () => {
    this.props.history.push({
      pathname: "/People/dashboard",
    });
  };
  static contextType = Mycontext;

  render() {
    const randValue = parseInt(window.sessionStorage.getItem("rValue"));
    

    const getRandomHoriCreative = () => {
      const withCta = this.adConfig.creative_cta === "With CTAs";
      
      if (withCta) {
        if (randValue === 1) {
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.MedizenHoriAddWithCTARep;
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.MedizenHoriAddWithCTASample;
          return htmls.MedizenHoriAddWithCta;
        }
        if (randValue === 2) {
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PrimeraHoriAddWithCTARep;
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PrimeraHoriAddWithCTASample;
          return htmls.PrimeraHoriAddWithCTA;
        }
        if (randValue === 3) {
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PanazHoriAddWithCTASample;
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PanazHoriAddWithCTARep;
          return htmls.PanazHoriAddWithCta;
        }
      } else {
        if (randValue === 1) {
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.MedizenHoriAddWithoutCTASample;
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.MedizenHoriAddWithoutCTARep;
          return htmls.MedizenHoriAddWithoutCTA;
        }
        if (randValue === 2) {
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PrimeraHoriAddWithoutCTARep;
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PrimeraHoriAddWithoutCTASample;
          return htmls.PrimeraHoriAddWithoutCTA;
        }
        if (randValue === 3) {
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PanazHoriAddWithoutCTASample;
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PanazHoriAddWithoutCTARep;
          return htmls.PanazHoriAddWithoutCTA;
        }
      }
    };

    const getRandomVertCreative = () => {
      const withCta = this.adConfig.creative_cta === "With CTAs";

      if (withCta) {
        if (randValue === 1) {
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.MedizenVertAddWithCTARep;
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.MedizenVertAddWithCTASample;
          return htmls.MedizenVertAddWithCta;
        }
        if (randValue === 2) {
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PrimeraVertAddWithCTASample;
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PrimeraVertAddWithCTARep;
          return htmls.PrimeraVertAddWithCTA;
        }
        if (randValue === 3) {
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PanazVertAddWithCTARep;
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PanazVertAddWithCTASample;
          return htmls.PanazVertAddWithCta;
        }
      } else {
        if (randValue === 1) {
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.MedizenVertAddWithoutCTASample;
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.MedizenVertAddWithoutCTARep;
          return htmls.MedizenVertAddWithoutCTA;
        }
        if (randValue === 2) {
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PrimeraVertAddWithoutCTARep;
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PrimeraVertAddWithoutCTASample;
          return htmls.PrimeraVertAddWithoutCTA;
        }
        if (randValue === 3) {
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PanazVertAddWithoutCTASample;
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PanazVertAddWithoutCTARep;
          return htmls.PanazVertAddWithoutCTA;
        }
      }
    };
    
    return (
      <>
        <Grid>
          <div>
            <Logo2 />
            <Sidebar />
          </div>
          <div style={{ width: "100%" }} className="customeGridArea">
            <Navbar Heading="Calendar" />
            <CustomDiv className="text-center">
              {/* <img
                src={AdVertical}
                alt="AdVertical"
                style={{ width: 668, height: 80 }}
              /> */}
              {/* <div>{loginAdsNew[randValue]}</div> */}
              <div className="iframeImageSection">
                {this.state.bannerType === "horizontal" && this.showAd && (
                  <iframe
                    srcDoc={getRandomHoriCreative()}
                  />
                )}
              </div>
              {/* <img src={loginAds1[randValue]} alt="addBanner"/> */}
            </CustomDiv>
            <div className="row1">
              <div className={this.state.bannerType === "vertical" && this.showAd ? "col-9":"col-12"}>
                <CustomDiv
                  style={{
                    marginTop: 20,
                    marginLeft: "22.5%",
                    fontWeight: 650,
                    fontSize: 16.1,
                    color: "#57585C",
                  }}
                >
                  <b> {moment().format("MMMM, DD, YYYY")}</b>
                  <b
                    style={{
                      marginLeft: "15px",
                      fontSize: 20,
                      fontWeight: 450,
                    }}
                  >
                    {" "}
                    ‹ ›
                  </b>
                </CustomDiv>
                <CalenderConatainer id="customeCalender">
                  <div>
                    <CustomCalender
                      calendarType={"US"}
                      onChange={this.onChange}
                      value={this.state.value}
                    />{" "}
                    <Provider />
                  </div>
                  <div style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                    <CustomPaper>
                      <Scheduler
                        data={appointments}
                        height={600}
                        showAllDayPanel={false}
                        dateCellRender={renderDateCell}
                      >
                        <WeekView startDayHour={13} endDayHour={18} />
                        <Appointments appointmentComponent={Appointment} />
                        <Resources
                          data={this.state.resources}
                          mainResourceName="id"
                        />
                      </Scheduler>
                    </CustomPaper>
                  </div>
                </CalenderConatainer>
              </div>
              {
                this.state.bannerType === "vertical" && this.showAd &&
                <div className="col-3 mt-60">
                {/* <div>{loginAdsNew[2]}</div> */}
                <div style={{ height: "100%" }}>
                  {this.state.bannerType === "vertical" && this.showAd && (
                    <iframe
                      style={{
                        display: "flex",
                        height: "100%",
                        width: "100%",
                      }}
                      srcDoc={getRandomVertCreative()}
                    />
                  )}
                </div>
              </div>
              }
              
            </div>
          </div>
        </Grid>
      </>
    );
  }
}
